import Box from 'components/shared/Box'
import Section from 'components/shared/Section'
import Text from 'components/shared/Text'
import { FormattedMessage, useIntl } from 'react-intl'
import Link from 'components/shared/Link'

import IconCard from 'assets/icons/voucher-icon_card.svg'
import IconValue from 'assets/icons/voucher-icon_value.svg'
import { VOUCHERS_LANDING_PAGE } from 'constants/links'
import VoucherTypeRadio from 'routes/vouchers/VouchersConfiguration/VoucherTypeRadio'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import { setVouchersType } from 'store/vouchers-slice'
import { VoucherType } from 'store/api-slice/types'
import { useAutoScroll } from 'utils/hooks'

const VoucherTypePicker = () => {
    const dispatch = useAppDispatch()
    const { formatMessage } = useIntl()
    const { calculateScroll } = useAutoScroll()

    const { vouchersType } = useAppSelector((state) => state.vouchers)

    const handleVoucherTypeChange = (option: VoucherType) => {
        if (option === vouchersType) return

        dispatch(setVouchersType(option))
        calculateScroll({
            trigerringSection: 'vouchers_configuration',
            trigerringAction: 'choose_type',
            targetId: 'voucherQuantityPicker',
        })
    }

    return (
        <Section>
            <Text variant="heading2" mb={32}>
                <FormattedMessage
                    id="vouchers.config.section_caption"
                    defaultMessage="Wybierz typ vouchera"
                />
            </Text>

            <Box isFullWidth direction={['column', 'row']} gap={16}>
                <VoucherTypeRadio
                    key="unlimited-card"
                    option="product"
                    id="unlimited-card"
                    icon={IconCard}
                    label={formatMessage({
                        id: 'vouchers.config.type_label_card',
                        defaultMessage: 'Karta Unlimited',
                    })}
                    teaser={formatMessage(
                        {
                            id: 'vouchers.config.type_teaser_card',
                            defaultMessage:
                                'Relaks w tropikach bez ograniczeń przez cały rok. <link>Poznaj szczegóły</link>',
                        },
                        {
                            link: (chunks: string[]) => (
                                <Link
                                    variant="primary"
                                    textVariant="bodySmall"
                                    path={VOUCHERS_LANDING_PAGE}
                                    target="_blank"
                                    icon={null}
                                    isUnderlined
                                    shouldStopPropagation
                                    data-testid="vouchers-redirect-unlimited-landing"
                                >
                                    {chunks}
                                </Link>
                            ),
                        }
                    )}
                    // TODO: organize better types for vouchersType (enum?)
                    isChecked={vouchersType === 'product'}
                    onClick={handleVoucherTypeChange}
                    testId="vouchers-select-type-card"
                />
                <VoucherTypeRadio
                    key="amount"
                    option="amount"
                    id="amount"
                    icon={IconValue}
                    label={formatMessage({
                        id: 'vouchers.config.type_label_value',
                        defaultMessage: 'Kwotowy',
                    })}
                    teaser={formatMessage({
                        id: 'vouchers.config.type_teaser_value',
                        defaultMessage:
                            'Podarunek na każdą okazję. Wybierz wielkość kwoty i sposób dostawy.',
                    })}
                    isChecked={vouchersType === 'amount'}
                    onClick={handleVoucherTypeChange}
                    testId="vouchers-select-type-amount"
                />
            </Box>
        </Section>
    )
}

export default VoucherTypePicker
